/* SOLVEXAX — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animaciones de entrada al hacer scroll */
  function initReveal() {
    var els = document.querySelectorAll('.sx-reveal:not(.sx-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sx-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave en imágenes marcadas con data-sx-parallax="intensidad" */
  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-sx-parallax]'));
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-sx-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -k).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Galería de producto */
  function initGallery() {
    document.querySelectorAll('[data-sx-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-sx-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-sx-thumb]'));
      if (!main || !thumbs.length) return;
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        main.classList.add('is-fading');
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.srcset = t.getAttribute('data-srcset') || '';
          main.alt = t.getAttribute('data-alt') || '';
          main.classList.remove('is-fading');
        }, 180);
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('[data-sx-prev]');
      var next = g.querySelector('[data-sx-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      var x0 = null;
      main.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* Cantidad + variantes en la página de producto */
  function initBuy() {
    document.querySelectorAll('[data-sx-buy]').forEach(function (box) {
      var qty = box.querySelector('[data-sx-qty]');
      box.querySelectorAll('[data-sx-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-sx-step'), 10));
        });
      });
      var dataEl = box.querySelector('[data-sx-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var selects = box.querySelectorAll('[data-sx-option], [data-sx-option-group]');
      function valOf(el) {
        if (el.tagName === 'SELECT') return el.value;
        var c = el.querySelector('input:checked'); return c ? c.value : null;
      }
      var idInput = box.querySelector('input[name="id"]');
      var priceNow = box.querySelector('[data-sx-price]');
      var priceWas = box.querySelector('[data-sx-compare]');
      var btn = box.querySelector('[data-sx-add]');
      var fmt = box.getAttribute('data-sx-money') || '${{amount_no_decimals_with_comma_separator}}';
      function money(cents) {
        var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
      }
      function onChange() {
        var chosen = Array.prototype.map.call(selects, valOf);
        box.querySelectorAll('.sx-pack').forEach(function (l) { var i = l.querySelector('input'); l.classList.toggle('is-active', !!(i && i.checked)); });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (priceWas) {
          priceWas.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        }
        var save = box.querySelector('[data-sx-save]');
        if (save) {
          save.hidden = !(v.compare_at_price > v.price);
          var amt = save.querySelector('[data-sx-save-amt]'); if (amt) amt.textContent = money(v.compare_at_price - v.price);
        }
        var sp = document.querySelector('[data-sx-sticky-price]'); if (sp) sp.textContent = money(v.price);
        var sc = document.querySelector('[data-sx-sticky-compare]'); if (sc) sc.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      selects.forEach(function (s) { s.addEventListener('change', onChange); });
      onChange();
    });
  }


  /* Pestañas genéricas: [data-sx-tabs] con botones [data-sx-tab="id"] y paneles [data-sx-panel="id"] */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-sx-tabs]').forEach(function (box) {
      if (box.__sxTabs) return; box.__sxTabs = true;
      var scope = box.getAttribute('data-sx-tabs');
      var container = box.closest('[data-sx-scope]') || document;
      var tabs = box.querySelectorAll('[data-sx-tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-sx-tab');
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
          container.querySelectorAll('[data-sx-panel-group="' + scope + '"]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-sx-panel') === id);
          });
        });
      });
    });
  }

  /* Paso a paso: clic en un paso lo marca y rellena la barra */
  function initSteps(root) {
    (root || document).querySelectorAll('[data-sx-steps]').forEach(function (list) {
      if (list.__sxSteps) return; list.__sxSteps = true;
      var steps = Array.prototype.slice.call(list.querySelectorAll('.sx-step'));
      var bar = list.parentElement.querySelector('.sx-steps__progress span');
      function go(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-current', k === i); s.classList.toggle('is-done', k < i); });
        if (bar) bar.style.width = ((i + 1) / steps.length * 100) + '%';
      }
      steps.forEach(function (s, i) {
        s.addEventListener('click', function () { go(i); });
        s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i); } });
      });
      go(0);
    });
  }

  /* Antes / después con deslizador */
  function initBA(root) {
    (root || document).querySelectorAll('[data-sx-ba]').forEach(function (ba) {
      if (ba.__sxBa) return; ba.__sxBa = true;
      var input = ba.querySelector('input[type=range]');
      if (!input) return;
      function set() { ba.style.setProperty('--sx-pos', input.value + '%'); }
      input.addEventListener('input', set);
      set();
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return; io.disconnect();
          var start = null, from = 50;
          function hint(ts) {
            if (!start) start = ts;
            var t = (ts - start) / 1400;
            if (t > 1) { input.value = 50; set(); return; }
            input.value = from + Math.sin(t * Math.PI * 2) * 18; set();
            requestAnimationFrame(hint);
          }
          requestAnimationFrame(hint);
        }, { threshold: 0.5 });
        io.observe(ba);
      }
    });
  }


  /* Guía paso a paso con anterior / siguiente */
  function initGuide(root) {
    (root || document).querySelectorAll('[data-sx-guide]').forEach(function (g) {
      if (g.__sxGuide) return; g.__sxGuide = true;
      var steps = Array.prototype.slice.call(g.querySelectorAll('[data-sx-guide-step]'));
      var prev = g.querySelector('[data-sx-guide-prev]');
      var next = g.querySelector('[data-sx-guide-next]');
      var n = g.querySelector('[data-sx-guide-n]');
      var bar = g.querySelector('.sx-steps__progress span');
      var cur = 0;
      function go(i) {
        cur = Math.max(0, Math.min(steps.length - 1, i));
        steps.forEach(function (s, k) { s.classList.toggle('is-current', k === cur); s.classList.toggle('is-done', k < cur); });
        if (n) n.textContent = cur + 1;
        if (bar) bar.style.width = ((cur + 1) / steps.length * 100) + '%';
        if (prev) prev.disabled = cur === 0;
        if (next) next.disabled = cur === steps.length - 1;
      }
      steps.forEach(function (s, i) { var h = s.querySelector('.sx-guide__head'); if (h) h.addEventListener('click', function () { go(i); }); });
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      go(0);
    });
  }

  /* Explorador de funciones: clic en una función cambia la foto */
  function initExplore(root) {
    (root || document).querySelectorAll('[data-sx-explore]').forEach(function (ex) {
      if (ex.__sxEx) return; ex.__sxEx = true;
      var items = ex.querySelectorAll('[data-sx-ex-item]');
      var imgs = ex.querySelectorAll('[data-sx-ex-img]');
      function show(i) {
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); it.setAttribute('aria-pressed', k === i); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-sx-ex-img') === String(i)); });
      }
      items.forEach(function (it, i) { it.addEventListener('click', function () { show(i); }); });
      show(0);
    });
  }


  /* Fecha estimada de llegada en días hábiles */
  function initEta() {
    document.querySelectorAll('[data-sx-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 1;
      var max = parseInt(el.getAttribute('data-max'), 10) || 3;
      function addBiz(d, n) { var r = new Date(d); var added = 0; while (added < n) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) added++; } return r; }
      var fmt = function (d) { try { return d.toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); } };
      var now = new Date();
      var tpl = el.getAttribute('data-tpl') || '· Llega entre el [desde] y el [hasta]';
      el.textContent = tpl.replace('[desde]', fmt(addBiz(now, min))).replace('[hasta]', fmt(addBiz(now, max)));
    });
  }

  /* Barra de compra fija: aparece cuando el botón principal sale de la pantalla */
  function initSticky() {
    var bar = document.querySelector('[data-sx-sticky]');
    var main = document.querySelector('[data-sx-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('footer, .sx-footer');
    var mainOut = false, footIn = false;
    function upd() {
      var show = mainOut && !footIn && main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', !show);
      document.body.classList.toggle('sx-has-sticky', show);
    }
    new IntersectionObserver(function (e) { mainOut = !e[0].isIntersecting; upd(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footIn = e[0].isIntersecting; upd(); }).observe(footer);
    var btn = bar.querySelector('[data-sx-sticky-btn]');
    if (btn) btn.addEventListener('click', function () { main.click(); });
  }

  /* Zoom de la foto principal siguiendo el cursor */
  function initZoom() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('.sx-gallery__main').forEach(function (box) {
      var img = box.querySelector('[data-sx-main]');
      if (!img) return;
      box.addEventListener('mousemove', function (e) {
        if (e.target.closest('button')) { box.classList.remove('is-zoom'); return; }
        var r = box.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        box.classList.add('is-zoom');
      });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-zoom'); });
    });
  }

  /* Video del producto: se reproduce solo (sin sonido) al aparecer en pantalla */
  function initReel(root) {
    (root || document).querySelectorAll('[data-sx-reel]').forEach(function (box) {
      if (box.dataset.sxReady) return; box.dataset.sxReady = '1';
      var v = box.querySelector('[data-sx-reel-video]');
      var bar = box.querySelector('[data-sx-reel-bar]');
      var snd = box.querySelector('[data-sx-reel-sound]');
      if (!v) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      v.addEventListener('play', function () { box.classList.add('is-playing'); });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
      box.addEventListener('click', function (e) {
        if (snd && snd.contains(e.target)) return;
        if (v.paused) play(); else v.pause();
      });
      if (snd) snd.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        box.classList.toggle('is-sound', !v.muted);
        snd.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar');
        if (!v.muted) { if (v.ended || v.currentTime > v.duration - 0.5) v.currentTime = 0; play(); }
      });
      if (!('IntersectionObserver' in window)) { if (!reduce) play(); return; }
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { if (!reduce || !v.muted) play(); }
        else if (!v.paused) v.pause();
      }, { threshold: 0.45 }).observe(box);
    });
    document.querySelectorAll('[data-sx-scroll-buy]').forEach(function (a) {
      if (a.dataset.sxReady) return; a.dataset.sxReady = '1';
      a.addEventListener('click', function (e) {
        var t = document.getElementById('sx-comprar'); if (!t) return;
        e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* Compras reales: ver más + ver en grande */
  function initProof(root) {
    (root || document).querySelectorAll('[data-sx-proof]').forEach(function (sec) {
      if (sec.dataset.sxReady) return; sec.dataset.sxReady = '1';
      var wall = sec.querySelector('[data-sx-proof-wall]');
      var more = sec.querySelector('[data-sx-proof-more]');
      var lb = sec.querySelector('[data-sx-proof-lb]');
      var big = sec.querySelector('[data-sx-proof-img]');
      if (more && wall) {
        var label = more.textContent;
        more.addEventListener('click', function () {
          var open = wall.classList.toggle('is-collapsed') === false;
          more.textContent = open ? (more.getAttribute('data-less') || label) : label;
          if (!open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      function close() { lb.hidden = true; document.documentElement.style.overflow = ''; }
      sec.querySelectorAll('[data-sx-proof-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          big.src = b.getAttribute('data-sx-proof-open'); lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      if (lb) lb.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb && !lb.hidden) close(); });
    });
  }

  function init() { initReveal(); initParallax(); initGallery(); initBuy(); initTabs(); initSteps(); initBA(); initGuide(); initExplore(); initEta(); initSticky(); initZoom(); initReel(); initProof(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(); initGallery(); initBuy(); initTabs(e.target); initSteps(e.target); initBA(e.target); initGuide(e.target); initExplore(e.target); initReel(e.target); initProof(e.target); });
})();
